import { DEFAULT_LOCALE, isSupportedLocale } from "../i18n/locales.js";
import { normalizeDisplayText } from "./textNormalization.js";

export const TODO_TRANSLATE = "TODO_TRANSLATE";

function isUsableTranslation(value) {
  return typeof value === "string" && value.trim().length > 0 && value !== TODO_TRANSLATE;
}

export function tField(field, requestedLocale = DEFAULT_LOCALE) {
  const locale = isSupportedLocale(requestedLocale) ? requestedLocale : DEFAULT_LOCALE;

  if (typeof field === "string") {
    return field === TODO_TRANSLATE ? "" : normalizeDisplayText(field, { collapseWhitespace: false });
  }

  if (!field || typeof field !== "object") {
    return "";
  }

  const candidates = [field[locale], field[DEFAULT_LOCALE], ...Object.values(field)];
  const value = candidates.find(isUsableTranslation);
  return value ? normalizeDisplayText(value, { collapseWhitespace: false }) : "";
}

export function hasTranslation(field, requestedLocale = DEFAULT_LOCALE) {
  return Boolean(field && typeof field === "object" && isUsableTranslation(field[requestedLocale]));
}
